import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 1,
  class: "remind-ball"
}
const _hoisted_3 = {
  key: 1,
  class: "label minishow"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 2,
  class: "form-components-link"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.item.type === 'textarea')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "form-components",
            style: {"margin":"0"}
          }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "form-components",
            style: {"margin":"0","flex":"unset"}
          }, null, -1))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.item&&_ctx.seen&&!(_ctx.item.field=='employerment_agreement_number'&&_ctx.signMode&&!_ctx.datavalue&&_ctx.autoGenerateEmploymenNumber))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["form-components", {'el-form-item is-error':_ctx.store.state.errorFileList.includes(_ctx.item.field)}]),
          style: _normalizeStyle(_ctx.item.type === 'textarea'?'flex:unset':'')
        }, [
          (!(_ctx.item.field=='department_address'&&_ctx.departmentRegionShow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field])
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: _ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field],
                      "popper-class": "remark-popper",
                      placement: "top-start",
                      trigger: "click"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("img", {
                          src: "https://images.goworkla.cn/wxAppletImg/EnergyValue_result_about.png",
                          class: "label-remark"
                        }, null, -1)
                      ])),
                      _: 1,
                      __: [3]
                    }, 8, ["content"]))
                  : _createCommentVNode("", true),
                (_ctx.item.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.item.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.item.field=='department_address'&&_ctx.departmentRegionShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.datavalue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datavalue) = $event)),
              modelModifiers: { trim: true },
              disabled: _ctx.item.is_disable,
              placeholder: _ctx.item.prompt_msg||`请输入${_ctx.item.name}`,
              type: _ctx.item.type||'text',
              autosize: {minRows: 2, maxRows: 4},
              resize: "none",
              onInput: _ctx.change
            }, null, 8, ["modelValue", "disabled", "placeholder", "type", "onInput"])
          ]),
          (_ctx.showLink&&_ctx.item.field=='department_name'&&_ctx.usertype!='wx')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `https://aiqicha.baidu.com/s?q=${_ctx.datavalue}`
                  }, "爱企查", 8, _hoisted_6)
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `https://www.tianyancha.com/search?key=${_ctx.datavalue}`
                  }, "天眼查", 8, _hoisted_7)
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `https://www.qcc.com/search?key=${_ctx.datavalue}`
                  }, "企查查", 8, _hoisted_8)
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: "http://www.gsxt.gov.cn/index.html"
                  }, "国家企业信息公示系统")
                ], -1))
              ]))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true)
  ], 64))
}